export enum ListSortType {
  Manual = 'manual',
  Alphabetical = 'alphabetical',
}
